export default function pluralize(num) {
    return num === 1 ? "" : "s";
}
